"use client"

import { useAppInitializer } from "@/components/providers/app-initializer-provider"

interface AppInitializerGateProps {
  children: React.ReactNode
  /**
   * 自定义加载组件，默认为空（不显示）
   * 如果需要显示加载动画，可以传入自定义组件
   */
  loadingFallback?: React.ReactNode
}

/**
 * 应用初始化门控组件
 * 只有在初始化完成后才渲染子组件，确保：
 * 1. 用户信息已加载（API 请求需要正确的 headers）
 * 2. 语言设置已完成（避免语言切换导致的闪烁）
 */
export default function AppInitializerGate({
  children,
  loadingFallback,
}: AppInitializerGateProps) {
  const { isInitialized, isInitializing } = useAppInitializer()

  // 如果正在初始化，显示加载状态（如果提供了 loadingFallback）
  if (isInitializing || !isInitialized) {
    // 如果没有提供自定义加载组件，返回 null（避免内容闪烁）
    // 注意：初始化通常很快（< 100ms），所以不显示加载动画是合理的
    return loadingFallback ? <>{loadingFallback}</> : null
  }

  return <>{children}</>
}

